import { ErrorMessage, useFormikContext } from 'formik';

import { CustomErrorMessage } from '@src/design-system/error-message';
import { Label } from '@src/design-system/label';
import { REMINDER_CHANNELS } from '@src/shared/types/reminder';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { getChannelSvg } from '@src/shared/features/reminders/helpers/get-channel-svg';
import { cn } from '@src/design-system/helpers';

import type { TCreateReminderFormValues } from './schema';

const CHANNEL_ORDER = [
  REMINDER_CHANNELS.whatsapp,
  REMINDER_CHANNELS.email,
  REMINDER_CHANNELS.sms,
] as const;

export function CreateReminderChannelCards() {
  const { values, setFieldValue } =
    useFormikContext<TCreateReminderFormValues>();

  return (
    <div>
      <Label className='text-sm font-medium text-gray-800'>Channel</Label>
      <div className='grid grid-cols-3 gap-3'>
        {CHANNEL_ORDER.map((channel) => (
          <button
            key={channel}
            type='button'
            onClick={() => {
              setFieldValue('notification_channel', channel);
              setFieldValue('template', undefined);
              setFieldValue('content', '');
              setFieldValue('attachments', []);
              setFieldValue('subject', '');
            }}
            className={cn(
              'flex h-19 cursor-pointer flex-col items-center justify-center gap-1 rounded-[8px] border px-2 text-sm transition-colors',
              values.notification_channel === channel
                ? 'border-primary-600 bg-primary-100 text-primary-1000'
                : 'border-primary-200 bg-white text-gray-800 hover:border-primary-400'
            )}
          >
            <img
              src={getChannelSvg(channel)}
              alt=''
              className='size-5!'
            />
            <span className='text-sm font-medium text-[#1A1535]'>
              {channel === REMINDER_CHANNELS.sms
                ? 'SMS'
                : formatTextForDisplay(channel)}
            </span>
          </button>
        ))}
      </div>
      <ErrorMessage
        name='notification_channel'
        component={CustomErrorMessage}
      />
    </div>
  );
}
